export const getParsedRedirects = () => {
  const redirects = sessionStorage.getItem('redirects') || '[]';
  return JSON.parse(redirects);
};

export const updateSessionStorage = ({ to, reason, component, pathname }) => {
  const parsedRedirects = getParsedRedirects();
  try {
    sessionStorage.setItem(
      'redirects',
      JSON.stringify([
        ...parsedRedirects,
        {
          to,
          reason,
          component,
          pathname,
          timestamp: new Date().toISOString().split('T')[1],
        },
      ]),
    );
  } catch (error) {
    console.error('Error updating session storage', error);
  }
};
